import React from 'react';

// 7 суточных слотов недели: засчитан / не засчитан / ещё впереди
export const HoldDays = ({ weekStartsAt, checks = [] }) => {
  const start = new Date(weekStartsAt).getTime();
  const byDay = new Map(checks.map((c) => [c.day, c.passed]));
  const slots = Array.from({ length: 7 }, (_, index) => {
    const day = new Date(start + index * 86400000).toISOString().slice(0, 10);
    return { index, passed: byDay.get(day) };
  });

  return (
    <div className="flex items-center space-x-[0.6rem]">
      {slots.map(({ index, passed }) => (
        <div
          key={index}
          className={`flex items-center justify-center w-[2.8rem] h-[2.8rem] rounded-full text-[1.2rem] font-500 border-[0.1rem] border-solid ${
            passed === true
              ? 'bg-[rgba(81,246,137,0.12)] border-[rgba(81,246,137,0.4)] text-green'
              : passed === false
              ? 'bg-[rgba(255,175,3,0.10)] border-[rgba(255,175,3,0.35)] text-[#FFAF03]'
              : 'border-white-100 text-white-500'
          }`}
        >
          {passed === true ? '✓' : passed === false ? '×' : index + 1}
        </div>
      ))}
    </div>
  );
};
